import { Button, Form, message, Modal } from "antd";
import { useContext, useEffect, useState } from "react";

import "./clientEscalation.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import moment from "moment";

import secureLocalStorage from "react-secure-storage";
import DuplicateTransactionReasonForm from "../audits/duplicateTransactionReasonForm";
import { JsonToExcel } from "react-json-to-excel";

import CustomLoader from "../../common/customLoader";
import media from "../../../media";
import TableContent from "../../../components/atoms/TableContent";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  completeClientEscalationsThunk,
  deleteClientEscalationsThunk,
  fetchClientEscalationsThunk,
  submitClientEscalationThunk,
} from "../../../store/thunks/clientEscalationsThunk";
import { exportJson } from "../../../utils/export";

const ClientEscalation = ({ children = null }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location?.pathname?.split("/")?.[2];
  const [tableForm] = Form.useForm();
  const navigate = useNavigate();

  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.qmsClientEscalations,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;

  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const [showLoader, setShowLoader] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [transactionDuplicateReason, setTransactionDuplicateReason] =
      useState(""),
    [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]),
    [visible, setVisible] = useState(false);
  const [clientEscalationLists, setClientEscalationLists] = useState([]);

  const showModal = () => {
    setGlobalState((prevGlobalState) => {
      return {
        ...prevGlobalState,
        eClientName: null,
        eClientNameVal: null,

        eClientSpocEmail: null,
        eClientSpocEmailVal: null,

        eEmpID: null,
        eEmpIDVal: null,

        eFinancialImpact: null,
        eFinancialImpactVal: null,

        eAgentName: null,
        eAgentNameVal: null,

        eAuditorName: null,
        eAuditorNameVal: null,

        eReportingTlName: null,
        eReportingTlNameVal: null,

        eDepartmentName: null,
        eDepartmentNameVal: null,

        eProcessName: null,
        eProcessNameVal: null,

        eErrorRaiseDate: null,
        eErrorRaiseDateVal: null,

        eTransactionId: null,
        eTransactionIdVal: null,

        eTransactionDate: null,
        eTransactionDateVal: null,

        eErrorDescription: null,
        eErrorDescriptionVal: null,

        eErrorInvestigationRemarks: null,
        eErrorInvestigationRemarksVal: null,

        eErrorImpact: null,
        eErrorImpactVal: null,

        eErrorArea: null,
        eErrorAreaVal: null,

        eErrorType: null,
        eErrorTypeVal: null,

        eErrorStatus: null,
        eErrorStatusVal: null,

        eDayoftheweek: null,
        eDayoftheweekVal: null,

        eAgentTenure: null,
        eAgentTenureVal: null,

        eFeedbackdate: null,
        eFeedbackdateVal: null,

        eRepeatedError: null,
        eRepeatedErrorVal: null,

        eCorrectiveActionTaken: null,
        eCorrectiveActionTakenVal: null,

        rcaLevelOne: null,
        rcaLevelOneVal: null,

        rcaLevelTwo: null,
        rcaLevelTwoVal: null,

        rcaLevelThree: null,
        rcaLevelThreeVal: null,

        rcaLevelFour: null,
        rcaLevelFourVal: null,
      };
    });
    setIsModalOpen(true);
  };

  // Fetch client-escalations
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchClientEscalationsThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          }),
        ).unwrap();

        if (res?.meta?.allTransactionIdsArr) {
          setAllTransactionIdsArr(res.meta.allTransactionIdsArr);
        }
        if (res?.meta?.clientEscalationLists) {
          setClientEscalationLists(res.meta.clientEscalationLists);
        }
      } catch (err) {
        console.error("Error fetching client-escalations:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, [currentPath, pagination.current, pagination.pageSize, dispatch]);

  {
    /*Setting state for showing Duplication Transaction ID popup as well as it value on Audits Detail Section*/
  }
  const onCreate = (values) => {
    values?.transactionDuplicateReason &&
      setTransactionDuplicateReason(values?.transactionDuplicateReason);
    //"Reason for duplicate Transaction ID"
    setGlobalState((prevGlobalState) => ({
      ...prevGlobalState,
      transactionDuplicateReason:
        values?.transactionDuplicateReason &&
        values?.transactionDuplicateReason,
    }));
    setVisible(false);
  };
  {
    /*Create CLient Escalation - Submit click*/
  }

  const handleOk = async () => {
    let submitFormModal = "";
    if (isModalVisible === true) {
      submitFormModal = "clickedOK";
    }

    const lIUId = secureLocalStorage.getItem("lIUId");

    if (
      globalState?.eClientName &&
      globalState?.eClientSpocEmail &&
      globalState?.eEmpID &&
      globalState?.eFinancialImpact &&
      (globalState?.eAgentName || globalState?.eAuditorName) &&
      globalState?.eDepartmentName &&
      globalState?.eProcessName &&
      globalState?.eReportingTlName &&
      globalState?.eErrorRaiseDateVal &&
      globalState?.eTransactionId &&
      globalState?.eTransactionDateVal &&
      globalState?.eErrorDescriptionVal &&
      globalState?.eErrorImpactVal &&
      globalState?.eErrorArea &&
      globalState?.eErrorType &&
      globalState?.eErrorStatus &&
      globalState?.eDayoftheweek &&
      globalState?.eAgentTenure &&
      globalState?.eFeedbackdate &&
      globalState?.eRepeatedError &&
      globalState?.eCorrectiveActionTaken &&
      globalState?.rcaLevelOneVal &&
      globalState?.rcaLevelTwoVal &&
      globalState?.rcaLevelThreeVal &&
      globalState?.rcaLevelFourVal
    ) {
      let transactionDate = moment(globalState?.eTransactionDateVal).format(
        "YYYY-MM-DD",
      );

      let eErrorRaiseDate = moment(globalState?.eErrorRaiseDateVal).format(
        "YYYY-MM-DD",
      );
      let createdAt = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      let createdBy = lIUId;
      let stage = "Completed";
      let status = "ACTIVE";
      if (submitFormModal === "clickedOK") {
        setIsModalOpen(false);
        setIsModalVisible(false);
        setVisible(false);
        const endpoint = `/client-escalation`;
        const method = "POST";
        const payload = {
          client: globalState?.eClientName,
          clientSpocEmail: globalState?.eClientSpocEmail,
          empID: globalState?.eEmpID,
          financialImpact: globalState?.eFinancialImpact,
          agent: globalState?.eAgentName,
          auditor: globalState?.eAuditorName,
          reportingTl: globalState?.eReportingTlName,
          department: globalState?.eDepartmentName,
          process: globalState?.eProcessName,
          transactionId: globalState?.eTransactionId,
          transactionDuplicateReason: transactionDuplicateReason,
          transactionDate: transactionDate,
          errorRaiseDate: eErrorRaiseDate,
          errorDescription: globalState?.eErrorDescription,
          errorInvestigationRemarks: globalState?.eErrorInvestigationRemarks,
          errorImpact: globalState?.eErrorImpact,
          errorArea: globalState?.eErrorArea,
          errorType: globalState?.eErrorType,
          errorStatus: globalState?.eErrorStatus,
          dayoftheweek: globalState?.eDayoftheweek,
          agentTenure: globalState?.eAgentTenure,
          feedbackdate: globalState?.eFeedbackdate,
          repeatedError: globalState?.eRepeatedError,
          correctiveActionTaken: globalState?.eCorrectiveActionTaken,
          rcaLevelOne: globalState?.rcaLevelOneVal,
          rcaLevelTwo: globalState?.rcaLevelTwoVal,
          rcaLevelThree: globalState?.rcaLevelThreeVal,
          rcaLevelFour: globalState?.rcaLevelFourVal,
          stage,
          status,
          createdAt,
          createdBy,
        };

        try {
          const response = await dispatch(
            submitClientEscalationThunk(payload),
          ).unwrap();

          if (response?._id) {
            navigate(`/escalations/client-escalation/${response._id}`, {
              state: {
                route: location.pathname,
                client: response?.client?.name,
                clientSpocEmail: response?.clientSpocEmail,
                empID: response?.empID,
                financialImpact: response?.eFinancialImpact,
                agent: response?.agent?.name,
                auditor: response?.auditor?.name,
                department: response?.department?.name,
                process: response?.process?.name,
                reportingTl: response?.reportingTl?.name,
                transactionDate: response?.transactionDate,
                transactionId: response?.eTransactionId,
                errorRaiseDate: response?.eErrorRaiseDate,
                errorDescription: response?.eErrorDescription,
                errorInvestigationRemarks: response?.eErrorInvestigationRemarks,
                errorImpact: response?.eErrorImpact,
                errorArea: response?.eErrorArea,
                errorType: response?.eErrorType,
                errorStatus: response?.eErrorStatus,
                dayoftheweek: response?.eDayoftheweek,
                agentTenure: response?.eAgentTenure,
                feedbackdate: response?.eFeedbackdate,
                repeatedError: response?.eRepeatedError,
                correctiveActionTaken: response?.eCorrectiveActionTaken,
                rcaLevelOne: response?.rcaLevelOne,
                rcaLevelTwo: response?.rcaLevelTwo,
                rcaLevelThree: response?.rcaLevelThree,
                rcaLevelFour: response?.rcaLevelFour,
              },
            });
          }
        } catch (err) {
          //API failed
          message.error(err?.message || "Failed to create client escalation");
        }
      } else {
        setIsModalOpen(true);
        setIsModalVisible(true);
      }
    } else if (
      allTransactionIdsArr.includes(globalState?.eTransactionIdVal) &&
      transactionDuplicateReason === ""
    ) {
      setIsModalOpen(true);
      setVisible(true);
    } else {
      setIsModalOpen(true);

      setGlobalState((prevGlobalState) => ({
        ...prevGlobalState,
        eClientName: globalState?.eClientNameVal
          ? globalState?.eClientNameVal
          : "Client Name is required",
        eClientSpocEmail: globalState?.eClientSpocEmailVal
          ? globalState?.eClientSpocEmailVal
          : "Client SPOC Email is required",
        eEmpID: globalState?.eEmpIDVal
          ? globalState?.eEmpIDVal
          : "Emp ID is required",
        eFinancialImpact: globalState?.eFinancialImpactVal
          ? globalState?.eFinancialImpactVal
          : "Financial Impact is required",
        eAgentName: globalState?.eAgentNameVal
          ? globalState?.eAgentNameVal
          : "Agent Name is required",
        eReportingTlName: globalState?.eReportingTlNameVal
          ? globalState?.eReportingTlNameVal
          : "Reporting TL is required",
        eDepartmentName: globalState?.eDepartmentNameVal
          ? globalState?.eDepartmentNameVal
          : "Department Name is required",
        eProcessName: globalState?.eProcessNameVal
          ? globalState?.eProcessNameVal
          : "Process Name is required",
        eErrorArea: globalState?.eErrorAreaVal
          ? globalState?.eErrorAreaVal
          : "Error Area is required",
        eErrorType: globalState?.eErrorTypeVal
          ? globalState?.eErrorTypeVal
          : "Error Type is required",
        eErrorRaiseDate: globalState?.eErrorRaiseDateVal
          ? globalState?.eErrorRaiseDateVal
          : "Error raise date is required",
        eTransactionId: globalState?.eTransactionIdVal
          ? globalState?.eTransactionIdVal
          : "Transaction ID is required",
        eTransactionDate: globalState?.eTransactionDateVal
          ? globalState?.eTransactionDateVal
          : "Transaction Date is required",
        eErrorDescription: globalState?.eErrorDescriptionVal
          ? globalState?.eErrorDescriptionVal
          : "Error description is required",
        eErrorImpact: globalState?.eErrorImpactVal
          ? globalState?.eErrorImpactVal
          : "Error impact is required",
        eErrorStatus: globalState?.eErrorStatusVal
          ? globalState?.eErrorStatusVal
          : "Error status is required",
        eDayoftheweek: globalState?.eDayoftheweekVal
          ? globalState?.eDayoftheweekVal
          : "Day of the week is required",
        eAgentTenure: globalState?.eAgentTenureVal
          ? globalState?.eAgentTenureVal
          : "Agent tenure is required",
        eFeedbackdate: globalState?.eFeedbackdateVal
          ? globalState?.eFeedbackdateVal
          : "Feedback date is required",
        eRepeatedError: globalState?.eRepeatedErrorVal
          ? globalState?.eRepeatedErrorVal
          : "Repeated error is required",
        eCorrectiveActionTaken: globalState?.eCorrectiveActionTakenVal
          ? globalState?.eCorrectiveActionTakenVal
          : "Corrective action taken is required",
        rcaLevelOne: globalState?.rcaLevelOneVal
          ? globalState?.rcaLevelOneVal
          : "RCA Level One is required",
        rcaLevelTwo: globalState?.rcaLevelTwoVal
          ? globalState?.rcaLevelTwoVal
          : "RCA Level Two is required",
        rcaLevelThree: globalState?.rcaLevelThreeVal
          ? globalState?.rcaLevelThreeVal
          : "RCA Level Three is required",
        rcaLevelFour: globalState?.rcaLevelFourVal
          ? globalState?.rcaLevelFourVal
          : "RCA Level Four is required",
      }));
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [selectionType, setSelectionType] = useState("checkbox");

  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            ID
          </div>
        );
      },
      dataIndex: "id",
      render: (text) => (
        <span className="rowStyle no-wrap">
          <Link
            to={"/escalations/client-escalation/" + text}
            style={{ color: "black" }}
          >
            <span
              className="rowStyle no-wrap"
              style={{ color: "#1875CB" }}
              onClick={() => {
                secureLocalStorage.setItem(
                  "fromComponent",
                  "client-escalation",
                );
              }}
            >
              {text}
            </span>
          </Link>
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Impact
          </div>
        );
      },
      dataIndex: "errorImpact",
      align: "center",
      render: (text) => (
        <span className="rowStyle no-wrap">
          {" "}
          <img
            src={
              text === "HIGH"
                ? "../high.png"
                : text === "MEDIUM"
                  ? "../medium.png"
                  : "../low.png"
            }
            style={{ width: "17px" }}
            alt="logo"
          />
          &nbsp;{}
        </span>
      ),
    },

    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.transactionId.svg} alt="icon" />
            Transaction ID
          </div>
        );
      },
      dataIndex: "transaction",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return (
          <span className="rowStyle no-wrap" title={text}>
            {truncatedText}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentName.svg} alt="icon" />
            Department
          </div>
        );
      },
      dataIndex: "department",
      render: (text) => <span className="rowStyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />
            Client
          </div>
        );
      },
      dataIndex: "client",
      render: (text) => <span className="rowStyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />
            Status
          </div>
        );
      },
      dataIndex: "stage",
      // render: (text) => (
      //   <span className="rowStyle no-wrap">
      //     {" "}
      //     <img
      //       src={
      //         text === "Audited"
      //           ? "../audited.PNG"
      //           : text === "Pending"
      //           ? "../pending.png"
      //           : text === "Completed"
      //           ? "../completed.png"
      //           : "../disputed.png"
      //       }
      //       style={{ width: "17px" }}
      //       alt="logo"
      //     />
      //     &nbsp;{text}
      //   </span>
      // ),
      render: (text) => (
        <span
          className={`cusStatus ${
            text?.toLowerCase() === "completed" ? "cusActive" : "cusInActive"
          }`}
        >
          {text}
        </span>
      ),
    },

    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Raised Date
          </div>
        );
      },
      dataIndex: "errorRaiseDate",
      render: (text) => <span className="rowStyle no-wrap">{text}</span>,
    },

    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.supervisor.svg} alt="icon" />
            Reporting TL
          </div>
        );
      },
      align: "center",
      dataIndex: "reportingTl",
      // render: (text) => {
      //   return (
      //     text && (
      //       <span className="rowStyle no-wrap">
      //         <>
      //           <img
      //             className="auditProfileImage"
      //             src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
      //             alt={text}
      //           />{" "}
      //           {text}
      //         </>
      //       </span>
      //     )
      //   );
      // },

      render: (text) => {
        if (!text) {
          return <span>-</span>;
        }
        const name = text || "";
        const firstLetter = name.charAt(0).toUpperCase();
        return (
          <span className="rowStyle no-wrap profileText">
            {text?.profilePicUrl ? (
              <img
                src={text.profilePicUrl}
                //src={media.profileIcon.svg}
                alt={text}
                className="tableProfile"
              />
            ) : (
              <span className="firstCaps">{firstLetter}</span>
            )}

            {name}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.agent.svg} alt="icon" />
            Agent
          </div>
        );
      },
      dataIndex: "agent",
      // render: (text) => {
      //   return (
      //     text && (
      //       <span className="rowStyle no-wrap">
      //         <>
      //           <img
      //             className="auditProfileImage"
      //             src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
      //             alt={text}
      //           />{" "}
      //           {text}
      //         </>
      //       </span>
      //     )
      //   );
      // },
      render: (text) => {
        if (!text) {
          return <span>-</span>;
        }
        const name = text || "";
        const firstLetter = name.charAt(0).toUpperCase();
        return (
          <span className="rowStyle no-wrap profileText">
            {text?.profilePicUrl ? (
              <img
                src={text.profilePicUrl}
                //src={media.profileIcon.svg}
                alt={text}
                className="tableProfile"
              />
            ) : (
              <span className="firstCaps">{firstLetter}</span>
            )}

            {name}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />
            Auditor
          </div>
        );
      },
      dataIndex: "auditor",
      // render: (text) => {
      //   return (
      //     text && (
      //       <span className="rowStyle no-wrap">
      //         <>
      //           {text?.name && (
      //             <img
      //               className="auditProfileImage"
      //               src={process.env.REACT_APP_BACKEND + "/images/dummy.jpg"}
      //               alt={text}
      //             />
      //           )}{" "}
      //           {text}
      //         </>
      //       </span>
      //     )
      //   );
      // },
      render: (text) => {
        if (!text) {
          return <span>-</span>;
        }
        const name = text || "";
        const firstLetter = name.charAt(0).toUpperCase();
        return (
          <span className="rowStyle no-wrap profileText">
            {text?.profilePicUrl ? (
              <img
                src={text.profilePicUrl}
                //src={media.profileIcon.svg}
                alt={text}
                className="tableProfile"
              />
            ) : (
              <span className="firstCaps">{firstLetter}</span>
            )}

            {name}
          </span>
        );
      },
    },
  ];

  {
    /*Export functionality on Client Escalation Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const isEditing = (record) => record.key === editingKey;

  const exportColumns = [
    { key: "Advisor Emp Code", path: "empID" },
    { key: "Advisor Agent", path: "agent" },
    { key: "Department", path: "department" },
    { key: "Process", path: "process" },
    { key: "Client Name", path: "client" },
    { key: "Client SPOC Email id", path: "clientSpocEmail" },
    {
      key: "Error Raise Date",
      path: "errorRaiseDate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    { key: "Reporting TL", path: "reportingTl" },
    { key: "Policy id / Transaction ID", path: "transactionId" },
    {
      key: "Transaction Duplicate Reason",
      path: "transactionDuplicateReason",
    },
    {
      key: "Transaction Date",
      path: "transactionDate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    { key: "Error Description", path: "errorDescription" },
    { key: "Error Impact", path: "errorImpact" },
    {
      key: "Error Investigation Remarks",
      path: "errorInvestigationRemarks",
    },
    { key: "Error Status", path: "errorStatus" },
    { key: "Rca Level One", path: "rcaLevelOne" },
    { key: "Rca Level Two", path: "rcaLevelTwo" },
    { key: "Rca Level Three", path: "rcaLevelThree" },
    { key: "Rca Level Four", path: "rcaLevelFour" },

    { key: "Day of the week", path: "dayoftheweek" },
    { key: "Advisor Tenure", path: "agentTenure" },
    {
      key: "Feedback Date",
      path: "feedbackdate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    { key: "Repeated Error", path: "repeatedError" },
    { key: "Revenue Impacted", path: "financialImpact" },
    { key: "Error Area", path: "errorArea" },
    { key: "Error Type", path: "errorType" },
    { key: "Stage", path: "stage" },
    {
      key: "Created At",
      path: "createdAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Updated At",
      path: "updatedAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
  ];

  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      exportJson(
        selectedRows,
        clientEscalationLists,
        "ClientEscalationReport",
        exportColumns,
        setGlobalState,
        globalState,
      );
    },
  };

  {
    /*Client Escalation Complete and Delete action*/
  }

  const handleClientEscalationAction = async (params) => {
    if (!globalState?.selectedRowKeysChildInfo?.length) {
      message.warning("Please select at least one record");
      return;
    }
    switch (params) {
      case "complete":
        const payload = {
          role: secureLocalStorage.getItem("role"),
          ids: globalState.selectedRowKeys,
        };

        try {
          await dispatch(completeClientEscalationsThunk(payload)).unwrap();

          message.success("Client escalation(s) completed successfully");

          // Reset selection
          setSelectedRowKeys([]);
          setGlobalState((prev) => ({
            ...prev,
            selectedRowKeys: [],
          }));

          // Refresh list
          await dispatch(
            fetchClientEscalationsThunk({
              searchIn: currentPath,
              callActionFrom: currentPath,
              hasSearchedValue: "",
              searchKeyword: "",
              route: currentPath,
              pagination: {
                current: pagination.current,
                page: pagination.current,
                pageSize: pagination.pageSize,
              },
            }),
          ).unwrap();
        } catch (err) {
          message.error(err?.message || "Failed to complete escalation(s)");
        }
      case "delete":
        let submitDeleteAuditFormModal = "";
        if (isDeleteModalVisible === true) {
          submitDeleteAuditFormModal = "clickedDeleteAuditOK";
        }
        if (submitDeleteAuditFormModal === "clickedDeleteAuditOK") {
          setShowLoader(true);

          const payload = {
            role: secureLocalStorage.getItem("role"),
            ids: globalState.selectedRowKeys,
          };

          try {
            await dispatch(deleteClientEscalationsThunk(payload)).unwrap();

            message.success("Client escalation(s) deleted successfully");

            setIsDeleteModalVisible(false);
            setSelectedRowKeys([]);
            setGlobalState((prev) => ({
              ...prev,
              selectedRowKeys: [],
            }));

            await dispatch(
              fetchClientEscalationsThunk({
                searchIn: currentPath,
                callActionFrom: currentPath,
                hasSearchedValue: "",
                searchKeyword: "",
                route: currentPath,
                pagination: {
                  current: pagination.current,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                },
              }),
            ).unwrap();
          } catch (err) {
            message.error(err?.message || "Delete failed");
          } finally {
            setShowLoader(false);
          }
        } else {
          setIsDeleteModalVisible(true);
        }
        break;
    }
  };

  const cancel = () => {
    setEditingKey("");
  };

  const isAdmin = secureLocalStorage.getItem("role") === "admin";
  const isAuditor = secureLocalStorage.getItem("role") === "auditor";
  const isQC = secureLocalStorage.getItem("role") === "qc";
  const isTL = secureLocalStorage.getItem("role") === "tl";
  const isQCSupervisor =
    isQC && secureLocalStorage.getItem("reportingSupervisor") === null;

  const hasSelectedRows =
    Array.isArray(globalState.selectedRowKeysChildInfo) &&
    globalState.selectedRowKeysChildInfo.length > 0;

  return (
    <>
      <div className="all-content">
        <CustomLoader showLoader={showLoader} />
        <TopContainerHeader
          sectionTitle="Client Escalation"
          sectionDescription={showLoader ? "Loading..." : `${count || 0} Found`}
          hasSectionButton={true}
          sectionButtons={[
            {
              isVisible: (isAdmin || isQC || isQCSupervisor) && hasSelectedRows,
              itemType: "downloadAsExcel",
              itemName: "",
              renderComponent: (
                <JsonToExcel
                  title={
                    <>
                      <img src={media.downloadIcon.svg} alt="icon" />
                      &nbsp;Download as Excel
                    </>
                  }
                  data={globalState.exportClientEscalationReportJson}
                  fileName="clientEscalationReport"
                  btnClassName="defaultBtn defaultGreyBtn"
                />
              ),
              itemClassName: "",
            },
            {
              isVisible: isAdmin && hasSelectedRows,
              itemType: "",
              itemName: "Delete",
              itemClassName: "escalationDelete auditDelete defaultGreyBtn",
              itemIcon: <i className="fa fa-trash" aria-hidden="true"></i>,
              onClick: () => handleClientEscalationAction("delete"),
            },
            {
              isVisible: true,
              itemType: "add",
              itemName: "Add",
              itemClassName: "performClientEscalation",
              onClick: () => showModal(),
            },
          ]}
          hasFilter={false}
          buttonTitle="Add New"
        />
        <div className="all-table-holder">
          <Form form={tableForm} component={false}>
            <TableContent
              rowSelection={rowSelection}
              bordered={false}
              columns={columns}
              dataSource={list}
              pagination={tablePagination}
            />
          </Form>
        </div>

        {(isAdmin || isQCSupervisor) && (
          <Modal
            className="all-modal cusWidthModal modal-lg"
            onCancel={handleCancel}
            onOk={handleOk}
            title={
              <div className="headermodaltitle">
                Create New Client Escalation
              </div>
            }
            open={isModalOpen}
            bodyStyle={{ height: "70vh", overflowY: "scroll" }}
            footer={[
              <div className="modalBtns">
                <Button
                  key="back"
                  className="defaultBtn defaultGreyBtn"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button key="submit" className="defaultBtn" onClick={handleOk}>
                  Create Client Escalation
                </Button>
              </div>,
            ]}
          >
            {children}
          </Modal>
        )}
      </div>
      <DuplicateTransactionReasonForm
        open={visible}
        setVisible={setVisible}
        onCreate={onCreate}
      />
      <Modal
        title="Confirmation!"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => {
          setIsModalVisible(false);
          setIsModalOpen(true);
        }}
        className="clientEscalationModal cusWidthModal"
        footer={[
          <div className="modalBtns">
            <Button
              key="back"
              className="defaultBtn defaultGreyBtn"
              onClick={() => {
                setIsModalVisible(false);
                setIsModalOpen(true);
              }}
            >
              Cancel
            </Button>
            <Button key="submit" className="defaultBtn" onClick={handleOk}>
              OK
            </Button>
          </div>,
        ]}
      >
        <p className="pb-16">
          Please review your selected or entered information carefully before
          submitting the form, as changes may not be possible once it's
          submitted.
        </p>
      </Modal>

      <Modal
        title="Confirmation!"
        open={isDeleteModalVisible}
        onCancel={() => {
          setIsDeleteModalVisible(false);
        }}
        className="clientEscalationModal"
        footer={[
          <div key="footer" className="modalBtns">
            <Button
              className="defaultBtn defaultGreyBtn"
              onClick={() => {
                setIsDeleteModalVisible(false);
              }}
            >
              No
            </Button>

            <Button
              className="defaultBtn"
              onClick={() => handleClientEscalationAction("delete")}
            >
              Yes
            </Button>
          </div>,
        ]}
      >
        <p className="pb-16">
          Are you sure you want to delete this client escalation?
        </p>
      </Modal>
    </>
  );
};
export default ClientEscalation;
